import styled from 'styled-components';

export const ButtonRow = styled.div`
  display: flex;
  justify-content: space-between;
`;
